export default function EACEntries() {
  return (
    <table id="filetable">
      <tr>
        <th>File Name</th>
        <th>Date Posted</th>
      </tr>

      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/eac/Morrisville-Riverfront-Preserve-Updated-2019.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Riverfront Preserve - Updated 2019
          </a>
        </td>
        <td>09/17/2024</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/eac/Tree-Initiative.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Tree Initiative
          </a>
        </td>
        <td>09/17/2024</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/eac/Homeowners-Tree-Planting-Guide.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Tree Planting Guide
          </a>
        </td>
        <td>09/17/2024</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/eac/Tree-Planting-Species-Recommendations.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Tree Planting Species Recommendations
          </a>
        </td>
        <td>09/17/2024</td>
      </tr>
      {/*End File*/}
    </table>
  );
}
